import { frontendURL } from '../../../helper/URLHelper';
import CustomMenuView from './pages/CustomMenuView.vue';

const customMenuRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/custom-menu/:menuId'),
      name: 'custom_menu_view',
      meta: {
        permissions: [
          'administrator',
          'agent',
          'conversation_manage',
          'conversation_unassigned_manage',
          'conversation_participating_manage',
        ],
      },
      component: CustomMenuView,
    },
  ],
};

export default customMenuRoutes;
